export const RouterServerContextSymbol = Symbol.for('@next/router-server-methods');
export const routerServerGlobal = globalThis;

//# sourceMappingURL=router-server-context.js.map